<template>
   <b-button
      @click="() => { modalState = true }"
      size="sm"
      :disabled="disabled"
      :variant="(httpRequestInProgress) ? 'success': 'primary'"
      block
   ><!-- button -->
      <span v-if="httpRequestInProgress">
      <b-spinner
         type="grow"
         label="Loading..."
         small
      ></b-spinner>
      </span>
      <span v-else>Bestellungserfüllung zurückziehen</span>
		 <b-modal
			 id="modal-unfreeze-order"
			 v-model="modalState"
			 title="Bestellungserfüllung zurückziehen?"
			 @ok="submit()"
			 cancel-title="abbrechen"
			 size="md"
			 header-class="border-0"
			 footer-class="border-0"
			 body-class="p-0"
		 >
		 </b-modal>
		 <modal-error-component v-model="errorModal"></modal-error-component>
   </b-button>
</template>
<script>
import ModalErrorComponent from "../ModalErrorComponent.vue";

export default {
	components: {ModalErrorComponent},
   props: ['customerOrderItemDelivery', 'customerOrderId', 'orderStates', 'authorization' ],
   data() {
      return {
         modalState: false,
         httpRequestInProgress: false,
         noSubmissionTime: false,
					errorModal: {
						show: false,
						message: '',
						error: null,
						title: 'Fehler beim Laden der Geräte',
					}
      };
   },
   computed: {
      disabled: function() {
         // "Alles über Mailer/Support – Berechtigungsseite Accountmanager" => interpretation: „Ab mailer_manager“ 
         // disable if user isn't at least mailer manager.
         console.log("COU-CDS: func disabled");
         if(!this.authorization.mailer_manager) return true;
         if(this.httpRequestInProgress) return true;
         if(!this.customerOrderItemDelivery) return true;
         if(this.customerOrderItemDelivery.deliverySubmissionTime) return true;
         console.log("COU-CDS: Delivery Time OK");
         return false; 
      }
   },
   methods: {
      submit() {
         let payload = {
            customerOrderItemDeliveryId: this.customerOrderItemDelivery.id,
            customerOrderId: this.customerOrderId
         }
         this.httpRequestInProgress = true;
				 axios.post('/customerorder/action/canceldeliverysubmission', payload).then( response => {
					 console.log(response);
            this.httpRequestInProgress = false;
            this.$emit('mutatedCustomerOrderItemDelivery', response.data);
         }).catch( error => {
            this.errorModal = {
							 show: true,
							 message: 'Die Bestellungserfüllung konnte nicht zurückgezogen werden.',
							 error: error,
							 title: 'Ein Fehler ist aufgetreten',
						};
            this.httpRequestInProgress = false;
            console.error(error);
         });
      }
   }
}
</script>
